// web跳app路由混淆map
const clientPaths = {
  default: {
    open_web_inside: 'open_web_inside',
    open_web_outside: 'open_web_outside',
    open_chat_page: 'open_chat_page',
    open_customer_service_page: 'open_customer_service_page',
    open_vip_page: 'open_vip_page',
    open_user_verify_page: 'open_user_verify_page',
    open_profile_page: 'open_profile_page',
    open_profile_edit_page: 'open_profile_edit_page',
    open_discover_page: 'open_discover_page',
    open_match_page: 'open_match_page',
    open_system_page: 'open_system_page',
    open_task_page: 'open_task_page',
    open_income_page: 'open_income_page',
    open_income_detail_page: 'open_income_detail_page',
    open_income_daily_report_page: 'open_income_daily_report_page',
    open_store_page: 'open_store_page',
    open_in_app_review: 'open_in_app_review',
    chat_open_input: 'chat_open_input',
    chat_send_picture: 'chat_send_picture',
    open_session_page: 'open_session_page',
    open_discover_post_page: 'open_discover_post_page',
    open_post_detail: 'open_post_detail',
    open_call_pass_recommend: 'open_call_pass_recommend',
    open_block_list: 'open_block_list',
    open_package_page: 'open_package_page',
    open_new_user_recharge_dialog: 'open_new_user_recharge_dialog',
    start_matching: 'start_matching',
    profile_edit_select_photo: 'profile_edit_select_photo',
    profile_edit_select_video: 'profile_edit_select_video',
    profile_edit_select_hobby: 'profile_edit_select_hobby',
    profile_edit_select_language: 'profile_edit_select_language',
    open_overlay_window_permission: 'open_overlay_window_permission',
    open_male_level_page: 'open_male_level_page',
    open_post_publish: 'open_post_publish',
    open_first_deposit_gift_pack_page: 'open_first_deposit_gift_pack_page',
    open_activity_pop_up: '',
    open_game: '',
  },
  echo: {
    open_web_inside: 'open_web_inside',
    open_web_outside: 'open_web_outside',
    open_chat_page: 'open_chat_page',
    open_customer_service_page: 'open_customer_service_page',
    open_vip_page: 'open_vip_page',
    open_user_verify_page: 'open_user_verify_page',
    open_profile_page: 'open_profile_page',
    open_profile_edit_page: 'open_profile_edit_page',
    open_discover_page: 'open_discover_page',
    open_match_page: 'open_match_page',
    open_system_page: 'open_system_page',
    open_task_page: 'open_task_page',
    open_income_page: 'open_income_page',
    open_income_detail_page: 'open_income_detail_page',
    open_income_daily_report_page: 'open_income_daily_report_page',
    open_store_page: 'open_store_page',
    open_in_app_review: 'open_in_app_review',
    chat_open_input: 'chat_open_input',
    chat_send_picture: 'chat_send_picture',
    open_session_page: 'open_session_page',
    open_discover_post_page: 'open_discover_post_page',
    open_post_detail: 'open_post_detail',
    open_call_pass_recommend: 'open_call_pass_recommend',
    open_block_list: 'open_block_list',
    open_package_page: 'open_package_page',
    open_new_user_recharge_dialog: 'open_new_user_recharge_dialog',
    start_matching: 'start_matching',
    profile_edit_select_photo: 'profile_edit_select_photo',
    profile_edit_select_video: 'profile_edit_select_video',
    profile_edit_select_hobby: 'profile_edit_select_hobby',
    profile_edit_select_language: 'profile_edit_select_language',
    open_overlay_window_permission: 'open_overlay_window_permission',
    open_male_level_page: 'open_male_level_page',
    open_post_publish: 'open_post_publish',
    open_first_deposit_gift_pack_page: 'open_first_deposit_gift_pack_page',
    open_activity_pop_up: '',
    open_game: '',
  },
  joychat: {
    open_web_inside: 'open_web_inside',
    open_web_outside: 'open_web_outside',
    open_chat_page: 'open_chat_page',
    open_customer_service_page: 'open_customer_service_page',
    open_vip_page: 'open_vip_page',
    open_user_verify_page: 'open_user_verify_page',
    open_profile_page: 'open_profile_page',
    open_profile_edit_page: 'open_profile_edit_page',
    open_discover_page: 'open_discover_page',
    open_match_page: 'open_match_page',
    open_system_page: 'open_system_page',
    open_task_page: 'open_task_page',
    open_income_page: 'open_income_page',
    open_income_detail_page: 'open_income_detail_page',
    open_income_daily_report_page: 'open_income_daily_report_page',
    open_store_page: 'open_store_page',
    open_in_app_review: 'open_in_app_review',
    chat_open_input: 'chat_open_input',
    chat_send_picture: 'chat_send_picture',
    open_session_page: 'open_session_page',
    open_discover_post_page: 'open_discover_post_page',
    open_post_detail: 'open_post_detail',
    open_call_pass_recommend: 'open_call_pass_recommend',
    open_block_list: 'open_block_list',
    open_package_page: 'open_package_page',
    open_new_user_recharge_dialog: 'open_new_user_recharge_dialog',
    start_matching: 'start_matching',
    profile_edit_select_photo: 'profile_edit_select_photo',
    profile_edit_select_video: 'profile_edit_select_video',
    profile_edit_select_hobby: 'profile_edit_select_hobby',
    profile_edit_select_language: 'profile_edit_select_language',
    open_overlay_window_permission: 'open_overlay_window_permission',
    open_male_level_page: 'open_male_level_page',
    open_post_publish: 'open_post_publish',
    open_first_deposit_gift_pack_page: 'open_first_deposit_gift_pack_page',
    open_activity_pop_up: '',
    open_game: '',
  },
  joyu: {
    open_web_inside: 'launch_integrated_browser',
    open_web_outside: 'open_web_outside',
    open_chat_page: 'open_messaging_interface',
    open_customer_service_page: 'contact_client_assistance',
    open_vip_page: 'navigate_to_vip_center',
    open_user_verify_page: 'open_user_verify_page',
    open_profile_page: 'view_user_details',
    open_profile_edit_page: 'begin_profile_adjustment',
    open_discover_page: 'enter_exploration_center',
    open_match_page: 'enter_pairing_screen',
    open_system_page: 'open_system_page',
    open_task_page: 'open_task_page',
    open_income_page: 'open_profit_analytics',
    open_income_detail_page: 'analyze_income_breakdown',
    open_income_daily_report_page: 'verify_daily_income_report',
    open_store_page: 'proceed_to_shop_interface',
    open_in_app_review: 'begin_evaluation_submission_process',
    chat_open_input: 'activate_chat_input_field',
    chat_send_picture: 'send_image_in_chat',
    open_session_page: 'open_message_inbox',
    open_discover_post_page: 'open_discover_post_page',
    open_post_detail: 'open_post_detail',
    open_call_pass_recommend: 'display_dial_credit_suggestion',
    open_block_list: 'open_block_list',
    open_package_page: 'discover_membership_plans',
    open_new_user_recharge_dialog: 'display_novice_recharge_suggestion',
    start_matching: 'start_matching',
    profile_edit_select_photo: 'profile_edit_select_photo',
    profile_edit_select_video: 'profile_edit_select_video',
    profile_edit_select_hobby: 'profile_edit_select_hobby',
    profile_edit_select_language: 'profile_edit_select_language',
    open_overlay_window_permission: 'open_overlay_window_permission',
    open_male_level_page: 'validate_male_subscription_level',
    open_post_publish: 'open_post_publish',
    open_first_deposit_gift_pack_page: 'access_welcome_deposit_bonus',
    open_activity_pop_up: 'show_advertisement_panel',
    open_game: 'open_game',
  },
  kiko: {
    open_web_inside: 'open_web_inside',
    open_web_outside: 'open_web_outside',
    open_chat_page: 'open_chat_page',
    open_customer_service_page: 'open_customer_service_page',
    open_vip_page: 'open_vip_page',
    open_user_verify_page: 'open_user_verify_page',
    open_profile_page: 'open_profile_page',
    open_profile_edit_page: 'open_profile_edit_page',
    open_discover_page: 'open_discover_page',
    open_match_page: 'open_match_page',
    open_system_page: 'open_system_page',
    open_task_page: 'open_task_page',
    open_income_page: 'open_income_page',
    open_income_detail_page: 'open_income_detail_page',
    open_income_daily_report_page: 'open_income_daily_report_page',
    open_store_page: 'open_store_page',
    open_in_app_review: 'open_in_app_review',
    chat_open_input: 'chat_open_input',
    chat_send_picture: 'chat_send_picture',
    open_session_page: 'open_session_page',
    open_discover_post_page: 'open_discover_post_page',
    open_post_detail: 'open_post_detail',
    open_call_pass_recommend: 'open_call_pass_recommend',
    open_block_list: 'open_block_list',
    open_package_page: 'open_package_page',
    open_new_user_recharge_dialog: 'open_new_user_recharge_dialog',
    start_matching: 'start_matching',
    profile_edit_select_photo: 'profile_edit_select_photo',
    profile_edit_select_video: 'profile_edit_select_video',
    profile_edit_select_hobby: 'profile_edit_select_hobby',
    profile_edit_select_language: 'profile_edit_select_language',
    open_overlay_window_permission: 'open_overlay_window_permission',
    open_male_level_page: 'open_male_level_page',
    open_post_publish: 'open_post_publish',
    open_first_deposit_gift_pack_page: 'open_first_deposit_gift_pack_page',
    open_activity_pop_up: '',
    open_game: '',
  },
  vava: {
    open_web_inside: 'open_web_inside',
    open_web_outside: 'open_web_outside',
    open_chat_page: 'open_chat_page',
    open_customer_service_page: 'open_customer_service_page',
    open_vip_page: 'open_vip_page',
    open_user_verify_page: 'open_user_verify_page',
    open_profile_page: 'open_profile_page',
    open_profile_edit_page: 'open_profile_edit_page',
    open_discover_page: 'open_discover_page',
    open_match_page: 'open_match_page',
    open_system_page: 'open_system_page',
    open_task_page: 'open_task_page',
    open_income_page: 'open_income_page',
    open_income_detail_page: 'open_income_detail_page',
    open_income_daily_report_page: 'open_income_daily_report_page',
    open_store_page: 'open_store_page',
    open_in_app_review: 'open_in_app_review',
    chat_open_input: 'chat_open_input',
    chat_send_picture: 'chat_send_picture',
    open_session_page: 'open_session_page',
    open_discover_post_page: 'open_discover_post_page',
    open_post_detail: 'open_post_detail',
    open_call_pass_recommend: 'open_call_pass_recommend',
    open_block_list: 'open_block_list',
    open_package_page: 'open_package_page',
    open_new_user_recharge_dialog: 'open_new_user_recharge_dialog',
    start_matching: 'start_matching',
    profile_edit_select_photo: 'profile_edit_select_photo',
    profile_edit_select_video: 'profile_edit_select_video',
    profile_edit_select_hobby: 'profile_edit_select_hobby',
    profile_edit_select_language: 'profile_edit_select_language',
    open_overlay_window_permission: 'open_overlay_window_permission',
    open_male_level_page: 'open_male_level_page',
    open_post_publish: 'open_post_publish',
    open_first_deposit_gift_pack_page: 'open_first_deposit_gift_pack_page',
    open_activity_pop_up: '',
    open_game: '',
  },
  vibeo: {
    open_web_inside: 'launch_web_view',
    open_web_outside: 'open_web_outside',
    open_chat_page: 'enter_chat_interface',
    open_customer_service_page: 'contact_customer_support',
    open_vip_page: 'navigate_to_vip_center',
    open_user_verify_page: 'open_user_verify_page',
    open_profile_page: 'show_user_profile',
    open_profile_edit_page: 'enter_profile_editing',
    open_discover_page: 'explore_discover_tab',
    open_match_page: 'browse_matching_screen',
    open_system_page: 'open_system_page',
    open_task_page: 'open_task_page',
    open_income_page: 'access_earnings_overview',
    open_income_detail_page: 'check_earnings_breakdown',
    open_income_daily_report_page: 'view_daily_earnings_report',
    open_store_page: 'go_to_store_interface',
    open_in_app_review: 'trigger_in_app_rating',
    chat_open_input: 'activate_chat_input_field',
    chat_send_picture: 'send_image_in_chat',
    open_session_page: 'open_conversation_list',
    open_discover_post_page: 'open_discover_post_page',
    open_post_detail: 'open_post_detail',
    open_call_pass_recommend: 'show_call_pass_suggestions',
    open_block_list: 'open_block_list',
    open_package_page: 'view_subscription_packages',
    open_new_user_recharge_dialog: 'show_new_user_recharge_prompt',
    start_matching: 'start_matching',
    profile_edit_select_photo: 'profile_edit_select_photo',
    profile_edit_select_video: 'profile_edit_select_video',
    profile_edit_select_hobby: 'profile_edit_select_hobby',
    profile_edit_select_language: 'profile_edit_select_language',
    open_overlay_window_permission: 'open_overlay_window_permission',
    open_male_level_page: 'navigate_male_level_info',
    open_post_publish: 'open_post_publish',
    open_first_deposit_gift_pack_page: 'display_first_deposit_bonus',
    open_activity_pop_up: '',
    open_game: '',
  },
  whonow: {
    open_web_inside: 'launch_inline_browser',
    open_web_outside: 'open_web_outside',
    open_chat_page: 'initiate_dialogue_gateway',
    open_customer_service_page: 'access_customer_assistance',
    open_vip_page: 'navigate_to_elite_center',
    open_user_verify_page: 'open_user_verify_page',
    open_profile_page: 'review_user_details',
    open_profile_edit_page: 'initiate_user_config_update',
    open_discover_page: 'access_exploration_arena',
    open_match_page: 'init_network_channel',
    open_system_page: 'open_system_page',
    open_task_page: 'open_task_page',
    open_income_page: 'initiate_profit_analysis',
    open_income_detail_page: 'assess_income_allocation',
    open_income_daily_report_page: 'verify_annual_income_report',
    open_store_page: 'proceed_to_retail_gateway',
    open_in_app_review: 'initiate_evaluation_submission_process',
    chat_open_input: 'activate_text_entry_field',
    chat_send_picture: 'relay_image_while_chatting',
    open_session_page: 'activate_alert_hub',
    open_discover_post_page: 'open_discover_post_page',
    open_post_detail: 'open_post_detail',
    open_call_pass_recommend: 'display_energy_level_suggestion',
    open_block_list: 'open_block_list',
    open_package_page: 'discover_subscription_plans',
    open_new_user_recharge_dialog: 'display_novice_recharge_suggestion',
    start_matching: 'start_matching',
    profile_edit_select_photo: 'profile_edit_select_photo',
    profile_edit_select_video: 'profile_edit_select_video',
    profile_edit_select_hobby: 'profile_edit_select_hobby',
    profile_edit_select_language: 'profile_edit_select_language',
    open_overlay_window_permission: 'open_overlay_window_permission',
    open_male_level_page: 'confirm_male_subscription_level',
    open_post_publish: 'open_post_publish',
    open_first_deposit_gift_pack_page: 'entry_greeting_initial_reward',
    open_game: 'open_game',
  },
  nivoa: {
    open_web_inside: 'launch_digital_gateway',
    open_web_outside: 'open_web_outside',
    open_chat_page: 'launch_console_bridge',
    open_customer_service_page: 'access_support_center',
    open_vip_page: 'open_vip_page',
    open_user_verify_page: 'open_user_verify_page',
    open_profile_page: 'show_individual_overview',
    open_profile_edit_page: 'launch_user_calibration',
    open_discover_page: 'enlarge_visual_panel',
    open_match_page: 'assess_interoperability_component',
    open_system_page: 'open_system_page',
    open_task_page: 'open_task_page',
    open_income_page: 'earnings_overview_control_panel',
    open_income_detail_page: 'validate_resource_allocation',
    open_income_daily_report_page: 'analyze_daily_earnings_overview',
    open_store_page: 'jump_to_commercial_hub',
    open_in_app_review: 'trigger_in_app_review',
    chat_open_input: 'chat_open_input',
    chat_send_picture: 'chat_send_picture',
    open_session_page: 'initiate_conversation_sequence',
    open_discover_post_page: 'open_discover_post_page',
    open_post_detail: 'open_post_detail',
    open_call_pass_recommend: 'render_execution_bypass_configuration',
    open_block_list: 'open_block_list',
    open_package_page: 'show_evaluation_structures',
    open_new_user_recharge_dialog: 'show_latest_customer_funding_alert',
    start_matching: 'start_matching',
    profile_edit_select_photo: 'profile_edit_select_photo',
    profile_edit_select_video: 'profile_edit_select_video',
    profile_edit_select_hobby: 'profile_edit_select_hobby',
    profile_edit_select_language: 'profile_edit_select_language',
    open_overlay_window_permission: 'open_overlay_window_permission',
    open_male_level_page: 'handbook_woman_executive_overview',
    open_post_publish: 'open_post_publish',
    open_first_deposit_gift_pack_page: 'display_startup_funding_bonus',
    open_activity_pop_up: 'display_dynamic_control_panel',
    open_game: '',
    go_back: 'ascend_propel',
  },
}

module.exports = clientPaths
